<template>
    <b-form id="source_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12">
                <p class="alert-warning" v-if="!editable">Это не ваш источник — можно изменить только емейл.</p>
                <b-form-group label="Название"
                              label-for="title">
                    <b-form-input id="title"
                                  type="text"
                                  :disabled="!editable"
                                  v-model="source.item.title">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !source.item.title">Заполните название</span>
                </b-form-group>
                <b-form-group label="Группа">
                    <v-select :options="groups" :disabled="!editable" v-model="source.item.group">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !source.item.group">Выберите группу</span>
                </b-form-group>
                <b-form-group label="Валюта">
                    <v-select :options="currency" :disabled="!editable" required v-model="source.item.currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !source.item.currency">Добавьте валюту</span>
                </b-form-group>
                <b-form-group label="Емейл"
                              label-for="email">
                    <b-form-input id="email"
                                  type="email"
                                  v-model="source.item.email">
                    </b-form-input>
                </b-form-group>
                <b-button type="submit" class="float-right"
                          variant="primary">Сохранить и выйти
                </b-button>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService'
    import SourcesService from '../../../services/sourcesDataService'

    export default {
        name: 'CreateSourceModal',
        components: {
            OffersService: OffersService
        },
        props: {
            source: {
                default: function () {
                    return {
                        title: null,
                        group: null,
                        currency: null,
                        email: null,
                    }
                }
            },
            // в чужом источнике можно менять только емейл
            editable: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                groups: [],
                currency: [],
                submitted: false
            }
        },
        methods: {
            onSubmit(evt) {
                // evt.preventDefault();
                this.submitted = true;

                if (!this.source.item.title || !this.source.item.group || !this.source.item.currency) {
                    evt.preventDefault();

                    return;
                }

                SourcesService.updateSource(this.source.item)
                    .then(function (response) {
                    })
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
        },
        beforeMount() {
            this.getCurrency();
            this.getGroups();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditSourceModal.vue